import BaseModel from '@/models/BaseModel';

class ImageModel extends BaseModel {
  // eslint-disable-next-line
  get defaults() {
    return {
      id: null,
      filename: '',
      original_filename: '',
      focal_point: {
        x: 0,
        y: 0,
      },
      file_url: '',
      uuid: '',
    };
  }
}

export default ImageModel;
